import NativeSelect from '@mui/material/NativeSelect';
import PropTypes from 'prop-types';

function GenericNativeSelect({ formik, field, children }) {
  return (
    <NativeSelect
      value={formik.values[field]}
      onChange={formik.handleChange}
      inputProps={{
        name: field,
        id: field,
      }}
      error={formik.touched[field] && Boolean(formik.errors[field])}>
      {children}
    </NativeSelect>
  );
}

GenericNativeSelect.propTypes = {
  formik: PropTypes.object,
  field: PropTypes.string,
  children: PropTypes.any,
};

export default GenericNativeSelect;
